import React from 'react';
import { LoadingIndicator, LoadingIndicatorColour } from 'acscp/components/common/loadingIndicator';

interface ButtonWithLoadingIndicatorProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading: boolean;
}

const ButtonWithLoadingIndicator: React.SFC<ButtonWithLoadingIndicatorProps> =
    ({isLoading, children, disabled, ...rest}) => {
        const isDisabled = isLoading || (disabled || false);
        return (
            <button disabled={isDisabled} {...rest}>
                {isLoading
                    ? <LoadingIndicator colour={LoadingIndicatorColour.White} />
                    : children}
            </button>
        );
    };

export {ButtonWithLoadingIndicator};
